export default function StatsSection() {
  const stats = [
    { number: '50,000+', label: '活跃用户' },
    { number: '12,000+', label: '成功举办活动' },
    { number: '8', label: '兴趣分类' },
    { number: '98%', label: '用户好评率' },
  ];

  return (
    <section className="w-full py-16 md:py-20 bg-primary-500">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading text-background-50 mb-3">
            用数据说话
          </h2>
          <p className="text-sm text-background-200">
            17c一起社区持续成长，越来越多的人在这里找到归属
          </p>
        </div>

        <div className="grid grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8">
          {stats.map((stat) => (
            <div key={stat.label} className="text-center">
              <p className="text-3xl md:text-4xl font-heading text-background-50 mb-2">
                {stat.number}
              </p>
              <p className="text-sm text-background-200 font-label">{stat.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}